import { render } from "./activityDataDetailModal.vue?vue&type=template&id=630cb8c0&scoped=true&ts=true"
import script from "./activityDataDetailModal.vue?vue&type=script&lang=ts"
export * from "./activityDataDetailModal.vue?vue&type=script&lang=ts"

import "./activityDataDetailModal.vue?vue&type=style&index=0&id=630cb8c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630cb8c0"]])

export default __exports__